// Check if the URL has the "?dev" parameter
const urlParams = new URLSearchParams(window.location.search);
const devMode = urlParams.has("dev");

// If we're in "dev mode", make all elements with the "dev-mode" class visible
if (devMode) {
    const devModeElements = document.querySelectorAll(".dev-mode");
    devModeElements.forEach((element) => {
        element.classList.remove('dev-mode')
    });
}




// function updateSessionStorage() {
//     const url = decodeURIComponent(window.location.href);
//
//     if (url.includes('/collections/')) {
//         const collectionName = url.split('/collections/')[1];
//         sessionStorage.setItem('lastVisitedCollection', collectionName);
//     }
//
//     if (url.includes('_sid')) {
//         sessionStorage.setItem('lastVisitedCollection', 'Search');
//     }
//
//     if (url.includes('_rid')) {
//         sessionStorage.setItem('lastVisitedCollection', `Recommendation: ${url.split('?_rid=')[1]}`);
//     }
//
//     if (url.includes('?_rid=recently-viewed')) {
//         sessionStorage.setItem('lastVisitedCollection', 'Recently Viewed');
//     }
//
//     if (url.includes('?fbclid=')) {
//         sessionStorage.setItem('ref', 'FB');
//     }
//
//     if (document.referrer.includes("google")) {
//         sessionStorage.setItem('ref', 'Google SEO');
//     }
//
//     if (url.includes('?gclid=')) {
//         sessionStorage.setItem('ref', 'Google Ads');
//     }
//
// }
//
// function updatePath() {
//     if(document.getElementById('is_from')){
//         const isFromInput = document.getElementById('is_from');
//         const lastVisitedCollection = sessionStorage.getItem('lastVisitedCollection');
//         isFromInput.value = lastVisitedCollection || 'Direct';
//         console.log(isFromInput.value)
//
//     }
// }
//
// function updateRef() {
//     if (document.getElementById('ref_from')){
//         const refFromInput = document.getElementById('ref_from');
//         const SessionRef = sessionStorage.getItem('ref');
//         refFromInput.value = SessionRef || 'Direct';
//         console.log(refFromInput.value)
//     }
// }
//
// document.addEventListener('theme:loading:end', () => {
//     updateSessionStorage()
//     updatePath();
//     console.log('updated 1');
// });
//
// window.onload = () => {
//     if (window.location.pathname === '/cart') {
//         updateRef();
//         console.log('updated 2');
//     }
// }
//
//
//
//

// MyDay: in the local preview (shopify theme dev), keep links that are
// hard-coded to the live domain on localhost. Does nothing on the live site.
if (['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href]');
        if (!link) return;
        const url = new URL(link.href, window.location.href);
        if (url.hostname === 'my-day.ge' || url.hostname === 'www.my-day.ge') {
            link.href = url.pathname + url.search + url.hash;
        }
    }, true);
}






